import axios from "axios";

export default {
  async findAll() {
    return axios.get(`/email-templates`);
  },
  async update(formData) {
    return axios.put(`/email-templates/${formData.id}`, formData);
  }
};
